// | ------------------------------------------------------------------------
// | Pages - About
// | ------------------------------------------------------------------------

// | ------------------------------------------------------------------------

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

document.addEventListener("DOMContentLoaded", function () {
  let numberObserverOptions = {
    rootMargin: "0px",
    threshold: 0.5,
  };

  var numberObserver = new IntersectionObserver(
    numberObserverCallback,
    numberObserverOptions
  );

  function numberObserverCallback(entries, observer) {
    entries.forEach((entry) => {
      const numberAnimate = () => {
        const speed = 100;
        const value = +entry.target.getAttribute("data-val");
        const data = +entry.target.innerText;
        const time = value / speed;

        if (data < value) {
          entry.target.innerText = Math.ceil(data + time);
          setTimeout(numberAnimate, 1);
        } else {
          var finalValue = numberWithCommas(value);
          entry.target.innerText = finalValue;
        }
      };

      if (entry.isIntersecting) {
        numberAnimate();
      } else {
        entry.target.innerText = 0;
      }
    });
  }

  let target = ".num";
  document.querySelectorAll(target).forEach((i) => {
    if (i) {
      numberObserver.observe(i);
    }
  });
});
